<main class="menu">
    <div id="background"></div>
    <header>
        <header-component></header-component>
        <div class="nav">
            <h1>{{_('qr_code_for_unlocking')}}</h1>
            <span class="icon back" @click="app.setPage('Terminal')">
                chevron_left
            </span>
        </div>
    </header>

    <section class="lockstate-qr-description">
        <h2>{{_('lockstate_qr_description_title')}}</h2>
        <p>{{_('lockstate_qr_description')}}</p>
    </section>
    <div class="room_numbers">
        <div
            class="card room_number"
            v-for="reserves_room in app.getReservesRoomsWithLockstateQr()"
            @click="app.lockstate_display_reserves_rooms = reserves_room"
        >
            {{reserves_room.name}}
        </div>
    </div>
    <hr />

    <div v-if="app.lockstate_display_reserves_rooms">
        <section class="checkin-code">
            <span>{{_('room_no')}}</span>
            <h2>{{app.lockstate_display_reserves_rooms.name}}</h2>
        </section>
        <section class="qr-image">
            <img
                class="qr_code_img"
                :src="app.lockstate_display_reserves_rooms.lockstate_qr"
            />
        </section>
        <section class="checkin-code">
            <span>{{_('key_no')}}</span>
            <h2>{{app.lockstate_display_reserves_rooms.lockstate_pin}}</h2>
        </section>
    </div>
    <tab-bar :page="app.query.page"></tab-bar>
</main>
